import React from 'react'
import { Flex, Box, Heading, Text } from 'rebass/styled-components'
import PropTypes from 'prop-types'

import Icomoon from '../Icomoon'
import ImageAnimations from './ImageAnimations'
import theme from '../../lib/theme'

const ExpandCard = ({ active, onClick, title, description, imageName, ...rest }) => {
  return (
    <Box
      onClick={onClick}
      active={active}
      p={5}
      bg="white"
      sx={{
        transition: 'all 0.165s ease-in-out',
        userSelect: 'none',
        cursor: 'pointer',
        boxShadow: '0px 8px 32px rgba(0, 0, 0, 0.03)',
        position: 'relative',
        borderRadius: '8px',

        '@media (min-width: 80rem)': {
          img: {
            display: 'none'
          }
        },

        '& p': active && {
          maxHeight: '500px'
        },

        '& svg': {
          transition: 'transform 0.365s ease-in-out',
          transform: active && 'rotate(-180deg)'
        }
      }}
      {...rest}
    >
      <Flex alignItems="center" justifyContent="space-between" mb={4}>
        <Heading
          as="h3"
          display="flex"
          alignItems="center"
          variant="level3"
          fontSize={theme.customFontsize(18, 24)}
          fontWeight="500"
          lineHeight="130%"
          sx={{
            '&::before': {
              content: "''",
              display: 'block',
              position: 'absolute',
              left: 0,
              width: '4px',
              height: '32px',
              bg: 'purple'
            }
          }}
        >
          {title}
        </Heading>

        <Box
          as="span"
          sx={{
            '@media (max-width: 32rem)': {
              display: 'none'
            }
          }}
        >
          <Icomoon icon="chevron-down" color="#727897" size="24px" />
        </Box>
      </Flex>

      <Box
        as="p"
        maxHeight="0px"
        sx={{
          transition: 'max-height 0.165s ease-in-out',
          overflow: 'hidden'
        }}
      >
        <Text variant="level6" color="gray2">
          {description}
        </Text>

        <Box>
          <ImageAnimations
            mt={5}
            mx="auto"
            type="left"
            width={1}
            imageName={imageName}
            maxWidth={['300px', '400px', '100%']}
          />
        </Box>
      </Box>
    </Box>
  )
}

ExpandCard.propTypes = {
  active: PropTypes.bool,
  onClick: PropTypes.func,
  title: PropTypes.string,
  description: PropTypes.string,
  imageName: PropTypes.string
}

export default ExpandCard
